export const templatePrelaunch = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Nemonto — Save your seat before we open the doors</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30;
    --spice-deep:#B23D18;
    --cream:#FAECE7;
    --peach:#F5C4B3;
    --charcoal:#2C2C2A;
    --herb:#1D9E75;
    --gold:#FAC775;
    --serif:'DM Serif Display', Georgia, serif;
    --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  body{
    background:var(--cream); color:var(--charcoal); font-family:var(--sans);
    overflow-x:hidden;
  }
  a{color:inherit; text-decoration:none;}
  button{font-family:inherit; cursor:pointer; border:none; background:none;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:3px; border-radius:4px;}
  .wrap{max-width:980px; margin:0 auto; padding:0 24px;}

  /* ---------- TOP BAR ---------- */
  .topbar{padding:22px 0; display:flex; align-items:center; justify-content:space-between;}
  .topbar-inner{max-width:980px; margin:0 auto; padding:0 24px; display:flex; align-items:center; justify-content:space-between; width:100%;}
  .logo{display:flex; align-items:center; gap:8px; font-family:var(--serif); font-size:20px;}
  .seats-pill{
    display:flex; align-items:center; gap:8px; background:rgba(216,90,48,0.1); color:var(--spice-deep);
    font-size:12.5px; font-weight:600; padding:8px 14px; border-radius:30px;
  }
  .seats-pill .dot{width:6px; height:6px; border-radius:50%; background:var(--spice); animation:pulse 1.8s infinite;}
  @keyframes pulse{0%,100%{opacity:1;}50%{opacity:0.3;}}

  /* ---------- HERO ---------- */
  .hero{padding:48px 0 0; text-align:center; position:relative;}
  .hero-bg{
    position:absolute; top:-140px; left:50%; transform:translateX(-50%); width:760px; height:760px;
    background:radial-gradient(circle, rgba(216,90,48,0.14), transparent 68%); pointer-events:none; z-index:0;
  }
  .hero-inner{position:relative; z-index:1;}
  .hero h1{
    font-family:var(--serif); font-size:clamp(38px,6vw,64px); line-height:1.05; color:var(--charcoal);
    max-width:760px; margin:0 auto 18px;
  }
  .hero h1 em{color:var(--spice); font-style:italic;}
  .hero p.sub{font-size:17px; color:#5A4F49; max-width:520px; margin:0 auto 40px; line-height:1.6;}

  /* ---------- SEAT TOGGLE (signature element) ---------- */
  .seat-toggle{
    display:inline-flex; background:rgba(44,44,42,0.06); border-radius:40px; padding:5px;
    margin-bottom:46px; position:relative;
  }
  .seat-btn{
    position:relative; z-index:1; padding:13px 26px; border-radius:34px; font-size:14.5px; font-weight:600;
    color:#6B5F58; display:flex; align-items:center; gap:8px; transition:color .25s ease;
  }
  .seat-btn.active{color:var(--cream);}
  .seat-slider{
    position:absolute; top:5px; left:5px; height:calc(100% - 10px); border-radius:30px;
    background:var(--spice); transition:transform .32s cubic-bezier(.65,0,.35,1), width .32s cubic-bezier(.65,0,.35,1);
    z-index:0;
  }

  /* ---------- PERSONA PANELS ---------- */
  .panel{display:none;}
  .panel.active{display:block; animation:fadein .4s ease;}
  @keyframes fadein{from{opacity:0; transform:translateY(8px);} to{opacity:1; transform:translateY(0);}}

  .persona-eyebrow{
    display:inline-flex; align-items:center; gap:8px; font-size:12.5px; font-weight:700; letter-spacing:0.06em;
    text-transform:uppercase; padding:7px 14px; border-radius:30px; margin-bottom:20px;
  }
  .persona-eyebrow.user{background:rgba(29,158,117,0.12); color:#0D6B4E;}
  .persona-eyebrow.creator{background:rgba(250,199,117,0.22); color:#8A5A00;}

  .panel-headline{font-family:var(--serif); font-size:clamp(28px,3.6vw,40px); line-height:1.18; max-width:640px; margin:0 auto 16px;}
  .panel-headline em{color:var(--spice); font-style:italic;}
  .panel-sub{font-size:16px; color:#5A4F49; max-width:520px; margin:0 auto 36px; line-height:1.6;}

  /* ---------- FORM ---------- */
  .signup-card{
    max-width:480px; margin:0 auto 16px; background:#fff; border-radius:24px; padding:8px;
    box-shadow:0 24px 50px -18px rgba(44,28,18,0.18);
    display:flex; gap:8px;
  }
  .signup-card input{
    flex:1; border:none; outline:none; padding:14px 18px; font-size:15px; font-family:var(--sans); background:transparent;
    color:var(--charcoal);
  }
  .signup-card input::placeholder{color:#B6A89F;}
  .signup-btn{
    background:var(--spice); color:var(--cream); padding:14px 24px; border-radius:18px; font-size:14.5px; font-weight:700;
    white-space:nowrap; transition:transform .18s, box-shadow .18s;
  }
  .signup-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}

  .creator-extra{
    max-width:480px; margin:0 auto 16px; display:flex; gap:10px;
  }
  .creator-extra select, .creator-extra input{
    flex:1; background:#fff; border:1.5px solid rgba(44,44,42,0.08); border-radius:14px; padding:13px 16px;
    font-size:13.5px; font-family:var(--sans); color:var(--charcoal); outline:none;
  }
  .creator-extra select:focus, .creator-extra input:focus{border-color:var(--spice);}

  .form-note{font-size:12.5px; color:#9A8C84; max-width:480px; margin:0 auto 56px;}
  .form-note b{color:var(--spice-deep);}

  /* ---------- PROOF ROW ---------- */
  .proof-row{display:flex; align-items:center; justify-content:center; gap:36px; flex-wrap:wrap; margin-bottom:90px;}
  .proof-item{text-align:center;}
  .proof-item b{display:block; font-family:var(--serif); font-size:26px; color:var(--spice-deep);}
  .proof-item span{font-size:12px; color:#9A8C84;}

  /* ---------- WHY SECTION (persona-specific) ---------- */
  .why-section{padding:0 0 100px;}
  .why-grid{display:grid; grid-template-columns:repeat(3,1fr); gap:22px; max-width:920px; margin:0 auto;}
  .why-card{
    background:#fff; border-radius:20px; padding:26px 22px; border:1px solid rgba(44,44,42,0.06);
    text-align:left;
  }
  .why-icon{width:42px; height:42px; border-radius:13px; display:flex; align-items:center; justify-content:center; margin-bottom:16px;}
  .why-card h3{font-family:var(--serif); font-size:18px; margin-bottom:8px; color:var(--charcoal);}
  .why-card p{font-size:13.5px; color:#6B5F58; line-height:1.55;}

  /* ---------- CERTIFICATE PREVIEW (creator only) ---------- */
  .cert-preview{
    max-width:380px; margin:0 auto 100px; background:var(--charcoal); border-radius:24px; padding:36px 30px;
    text-align:center; box-shadow:0 30px 60px -20px rgba(44,28,18,0.35); position:relative;
  }
  .cert-preview .ctop{font-size:11px; letter-spacing:0.12em; text-transform:uppercase; color:var(--spice); margin-bottom:16px;}
  .cert-preview .cname{font-family:var(--serif); font-size:24px; color:var(--gold); font-style:italic; margin:14px 0 6px;}
  .cert-preview .csub{font-size:12px; color:rgba(250,236,231,0.55); line-height:1.6; margin-bottom:18px;}
  .cert-preview .cbadge{display:inline-block; background:var(--spice); color:var(--cream); font-size:12px; font-weight:700; padding:7px 16px; border-radius:20px;}
  .cert-blank-num{color:rgba(250,236,231,0.35);}

  /* ---------- TIMELINE (user only) ---------- */
  .timeline{max-width:560px; margin:0 auto 100px; position:relative;}
  .timeline::before{content:''; position:absolute; left:15px; top:8px; bottom:8px; width:2px; background:rgba(44,44,42,0.12);}
  .tl-item{display:flex; gap:20px; margin-bottom:32px; position:relative;}
  .tl-item:last-child{margin-bottom:0;}
  .tl-dot{
    width:32px; height:32px; border-radius:50%; background:#fff; border:2px solid var(--spice); flex-shrink:0;
    display:flex; align-items:center; justify-content:center; font-size:13px; font-weight:700; color:var(--spice-deep);
    position:relative; z-index:1;
  }
  .tl-dot.done{background:var(--spice); color:#fff; border-color:var(--spice);}
  .tl-body h4{font-family:var(--serif); font-size:17px; margin-bottom:4px; color:var(--charcoal);}
  .tl-body p{font-size:13.5px; color:#6B5F58; line-height:1.5;}
  .tl-when{font-size:11.5px; color:var(--spice-deep); font-weight:600; margin-top:4px; display:block;}

  /* ---------- FAQ ---------- */
  .faq-section{background:var(--peach); padding:90px 0;}
  .faq-list{max-width:680px; margin:0 auto;}
  .faq-item{background:rgba(255,255,255,0.6); border-radius:16px; margin-bottom:12px; overflow:hidden;}
  .faq-q{
    width:100%; text-align:left; padding:18px 22px; display:flex; align-items:center; justify-content:space-between;
    font-size:14.5px; font-weight:600; color:var(--charcoal);
  }
  .faq-q svg{transition:transform .25s ease; flex-shrink:0;}
  .faq-item.open .faq-q svg{transform:rotate(45deg);}
  .faq-a{padding:0 22px; max-height:0; overflow:hidden; transition:max-height .3s ease, padding .3s ease;}
  .faq-item.open .faq-a{max-height:200px; padding:0 22px 20px;}
  .faq-a p{font-size:13.5px; color:#5A4F49; line-height:1.6;}

  /* ---------- FINAL CTA ---------- */
  .final{padding:100px 0 80px; text-align:center;}
  .final h2{font-family:var(--serif); font-size:clamp(30px,4.4vw,46px); margin-bottom:16px;}
  .final h2 em{color:var(--spice); font-style:italic;}
  .final p{font-size:15.5px; color:#5A4F49; max-width:440px; margin:0 auto 32px;}

  footer{padding:32px 0; text-align:center; font-size:12.5px; color:#9A8C84;}

  @media (max-width:720px){
    .why-grid{grid-template-columns:1fr;}
    .signup-card{flex-direction:column; padding:10px;}
    .signup-card input{padding:12px 14px;}
    .creator-extra{flex-direction:column;}
    .proof-row{gap:24px;}
    .seat-btn{padding:11px 18px; font-size:13.5px;}
  }
</style>
</head>
<body>

<div class="topbar">
  <div class="topbar-inner">
    <div class="logo">
      <svg width="26" height="26" viewBox="0 0 100 100" aria-hidden="true">
        <ellipse cx="50" cy="74" rx="30" ry="6" fill="#993C1D" opacity="0.5"/>
        <path d="M20 50 Q20 78 50 78 Q80 78 80 50 Z" fill="#D85A30"/>
        <path d="M18 47 Q18 53 23 53 L77 53 Q82 53 82 47 Q82 38 50 38 Q18 38 18 47 Z" fill="#FAECE7"/>
        <path d="M34 30 Q31 22 34 13" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
        <path d="M50 27 Q47 19 50 10" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
        <path d="M66 30 Q63 22 66 13" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
      </svg>
      nemonto
    </div>
    <div class="seats-pill"><span class="dot"></span><span id="seatsCount">47 of 100 founding seats claimed</span></div>
  </div>
</div>

<header class="hero">
  <div class="hero-bg"></div>
  <div class="wrap hero-inner">
    <h1>The doors aren't open yet.<br><em>Your seat already is.</em></h1>
    <p class="sub">Nemonto — a Bengali word for dinner invitation — opens in New York City soon. Tell us who you are, and we'll save you a place at the table.</p>

    <div class="seat-toggle" id="seatToggle">
      <div class="seat-slider" id="seatSlider"></div>
      <button class="seat-btn active" data-panel="user" id="btnUser">🍽️ I want to cook</button>
      <button class="seat-btn" data-panel="creator" id="btnCreator">⚑ I'm a creator</button>
    </div>

    <!-- ===== USER PANEL ===== -->
    <div class="panel active" id="panel-user">
      <span class="persona-eyebrow user">Early access</span>
      <h2 class="panel-headline">Be cooking before<br>anyone <em>else hears about it.</em></h2>
      <p class="panel-sub">Early members get first access when we launch in your city, a head start on the home feed, and a permanent "Early Table" badge that never goes away.</p>

      <div class="signup-card">
        <input type="email" placeholder="you@email.com" aria-label="Email address">
        <button class="signup-btn">Save my seat</button>
      </div>
      <p class="form-note">No spam, ever. Just one email when it's your turn to come in.</p>

      <div class="proof-row">
        <div class="proof-item"><b>300+</b><span>home cooks waiting</span></div>
        <div class="proof-item"><b>NYC</b><span>first city, more soon</span></div>
        <div class="proof-item"><b>Free</b><span>forever to join</span></div>
      </div>
    </div>

    <!-- ===== CREATOR PANEL ===== -->
    <div class="panel" id="panel-creator">
      <span class="persona-eyebrow creator">Founding creator</span>
      <h2 class="panel-headline">Bring your followers.<br>Keep <em>the recognition.</em></h2>
      <p class="panel-sub">The first 100 creators get a permanent founding badge, lifetime Pro access, and first right to host challenges — before Nemonto ever opens to the public.</p>

      <div class="signup-card">
        <input type="email" placeholder="you@email.com" aria-label="Email address">
        <button class="signup-btn">Apply now</button>
      </div>
      <div class="creator-extra">
        <input type="text" placeholder="@ your handle" aria-label="Social handle">
        <select aria-label="Primary platform">
          <option>Instagram</option>
          <option>TikTok</option>
          <option>YouTube</option>
          <option>Other</option>
        </select>
      </div>
      <p class="form-note">We review every application personally — <b>usually within 48 hours.</b></p>

      <div class="proof-row">
        <div class="proof-item"><b>47</b><span>of 100 seats claimed</span></div>
        <div class="proof-item"><b>♾</b><span>free Pro, for life</span></div>
        <div class="proof-item"><b>#1–100</b><span>numbered, forever</span></div>
      </div>
    </div>

  </div>
</header>

<!-- ===== WHY SECTION — USER ===== -->
<section class="why-section panel active" id="why-user">
  <div class="wrap">
    <div class="why-grid">
      <div class="why-card">
        <div class="why-icon" style="background:rgba(216,90,48,0.12);">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 12l6 6L20 6" stroke="#D85A30" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
        <h3>Real proof, not ratings</h3>
        <p>Every recipe shows how many people actually cooked it — and how it went. No five-star reviews from people who never made the dish.</p>
      </div>
      <div class="why-card">
        <div class="why-icon" style="background:rgba(29,158,117,0.12);">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M8 21h8M12 17v4M7 4h10v4a5 5 0 01-10 0V4z" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
        <h3>Win something real</h3>
        <p>Enter a cooking challenge and get judged by an actual creator — not an algorithm deciding who got the most likes.</p>
      </div>
      <div class="why-card">
        <div class="why-icon" style="background:rgba(250,199,117,0.22);">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M5 12c0-4 3-7 7-7s7 3 7 7-3 7-7 7" stroke="#BA7517" stroke-width="1.8" stroke-linecap="round"/><path d="M9 19l-2 2M15 19l2 2" stroke="#BA7517" stroke-width="1.8" stroke-linecap="round"/></svg>
        </div>
        <h3>No ads in your feed</h3>
        <p>Just recipes from people who made them, in their actual kitchens. We make money from Pro features, not your attention.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== WHY SECTION — CREATOR ===== -->
<section class="why-section panel" id="why-creator">
  <div class="wrap">
    <div class="why-grid">
      <div class="why-card">
        <div class="why-icon" style="background:rgba(250,199,117,0.22);">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 2l2.5 6.5L21 9l-5 4.5L17.5 21 12 17l-5.5 4L8 13.5 3 9l6.5-.5z" stroke="#BA7517" stroke-width="1.6" stroke-linejoin="round"/></svg>
        </div>
        <h3>A badge that never expires</h3>
        <p>Founding creators are numbered #1–100, permanently. Even at 5 million users, your profile shows you were here first.</p>
      </div>
      <div class="why-card">
        <div class="why-icon" style="background:rgba(216,90,48,0.12);">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="#D85A30" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
        <h3>You set the rules</h3>
        <p>Host the first challenges on the platform. The ingredients, the cuisine, the clock — you define what a Nemonto challenge feels like.</p>
      </div>
      <div class="why-card">
        <div class="why-icon" style="background:rgba(29,158,117,0.12);">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 11l18-7-7 18-2-8-9-3z" stroke="#1D9E75" stroke-width="1.8" stroke-linejoin="round"/></svg>
        </div>
        <h3>We promote you, not the other way</h3>
        <p>Every week we spotlight a founding creator on our own channels. You bring your audience in — we help it grow from there.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== CREATOR-ONLY CERTIFICATE PREVIEW ===== -->
<section class="panel" id="cert-section">
  <div class="wrap">
    <div class="cert-preview">
      <p class="ctop">Nemonto · Founding Creator</p>
      <svg width="56" height="56" viewBox="0 0 100 100" style="margin:0 auto;">
        <ellipse cx="50" cy="74" rx="30" ry="6" fill="#993C1D" opacity="0.5"/>
        <path d="M20 50 Q20 78 50 78 Q80 78 80 50 Z" fill="#D85A30"/>
        <path d="M18 47 Q18 53 23 53 L77 53 Q82 53 82 47 Q82 38 50 38 Q18 38 18 47 Z" fill="#FAECE7"/>
        <path d="M34 30 Q31 22 34 13" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
        <path d="M50 27 Q47 19 50 10" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
        <path d="M66 30 Q63 22 66 13" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
      </svg>
      <p class="cname">This could be you</p>
      <p class="csub">Apply above to claim your spot.<br>Dinner invitation. Pending.</p>
      <span class="cbadge">Founding Creator #<span class="cert-blank-num">??</span></span>
    </div>
  </div>
</section>

<!-- ===== TIMELINE — USER ONLY ===== -->
<section class="panel" id="timeline-section">
  <div class="wrap">
    <div class="timeline">
      <div class="tl-item">
        <div class="tl-dot done">✓</div>
        <div class="tl-body">
          <h4>You save your seat</h4>
          <p>Drop your email above — takes ten seconds, no account needed yet.</p>
          <span class="tl-when">Today</span>
        </div>
      </div>
      <div class="tl-item">
        <div class="tl-dot">2</div>
        <div class="tl-body">
          <h4>Founding creators start posting</h4>
          <p>The first 100 creators seed the feed with real recipes — so it's never empty when you arrive.</p>
          <span class="tl-when">Next few weeks</span>
        </div>
      </div>
      <div class="tl-item">
        <div class="tl-dot">3</div>
        <div class="tl-body">
          <h4>You get the invite</h4>
          <p>We open the doors in waves, earliest signups first. You'll get an email the moment it's your turn.</p>
          <span class="tl-when">Launch window</span>
        </div>
      </div>
      <div class="tl-item">
        <div class="tl-dot">4</div>
        <div class="tl-body">
          <h4>Pull up a chair</h4>
          <p>Post your first recipe, try someone else's, or jump straight into a live challenge.</p>
          <span class="tl-when">Day one</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="faq-section">
  <div class="wrap faq-list">
    <div class="faq-item">
      <button class="faq-q">Is Nemonto free? <svg width="16" height="16" viewBox="0 0 16 16"><path d="M8 3v10M3 8h10" stroke="#2C2C2A" stroke-width="1.6" stroke-linecap="round"/></svg></button>
      <div class="faq-a"><p>Yes, completely free to join and use. There's an optional Pro tier later for advanced features, but the core app — posting, cooking, challenges — stays free.</p></div>
    </div>
    <div class="faq-item">
      <button class="faq-q">Which cities are launching first? <svg width="16" height="16" viewBox="0 0 16 16"><path d="M8 3v10M3 8h10" stroke="#2C2C2A" stroke-width="1.6" stroke-linecap="round"/></svg></button>
      <div class="faq-a"><p>We're starting in New York City to get the community right before expanding. If you're outside NYC, save your seat anyway — your city is next.</p></div>
    </div>
    <div class="faq-item">
      <button class="faq-q">How are founding creators chosen? <svg width="16" height="16" viewBox="0 0 16 16"><path d="M8 3v10M3 8h10" stroke="#2C2C2A" stroke-width="1.6" stroke-linecap="round"/></svg></button>
      <div class="faq-a"><p>We review every application personally — we're looking for people who genuinely love cooking and post consistently, not follower count alone. Most applicants hear back within 48 hours.</p></div>
    </div>
    <div class="faq-item">
      <button class="faq-q">What if I'm not a "creator," just someone who cooks? <svg width="16" height="16" viewBox="0 0 16 16"><path d="M8 3v10M3 8h10" stroke="#2C2C2A" stroke-width="1.6" stroke-linecap="round"/></svg></button>
      <div class="faq-a"><p>That's exactly who Nemonto is for. Most people on the app aren't influencers — they're home cooks posting what they actually made for dinner. Pick "I want to cook" above.</p></div>
    </div>
  </div>
</section>

<section class="final">
  <div class="wrap">
    <h2>Dinner's almost ready.<br><em>Don't miss the invite.</em></h2>
    <p>Scroll up, drop your email, and we'll let you know the moment your seat is ready.</p>
    <button class="signup-btn" style="padding:15px 32px; font-size:15px;" onclick="window.scrollTo({top:0,behavior:'smooth'})">Save my seat ↑</button>
  </div>
</section>

<footer>
  © 2026 Nemonto. You're invited to the table.
</footer>

<script>
  const btnUser = document.getElementById('btnUser');
  const btnCreator = document.getElementById('btnCreator');
  const slider = document.getElementById('seatSlider');
  const toggle = document.getElementById('seatToggle');

  const panels = {
    user: [document.getElementById('panel-user'), document.getElementById('why-user'), document.getElementById('timeline-section')],
    creator: [document.getElementById('panel-creator'), document.getElementById('why-creator'), document.getElementById('cert-section')]
  };

  function setSlider(btn){
    const tw = toggle.getBoundingClientRect();
    const bw = btn.getBoundingClientRect();
    slider.style.width = bw.width + 'px';
    slider.style.transform = \`translateX(\${bw.left - tw.left - 5}px)\`;
  }

  function showPersona(name){
    btnUser.classList.toggle('active', name === 'user');
    btnCreator.classList.toggle('active', name === 'creator');
    setSlider(name === 'user' ? btnUser : btnCreator);

    Object.entries(panels).forEach(([key, els]) => {
      els.forEach(el => el.classList.toggle('active', key === name));
    });
  }

  btnUser.addEventListener('click', () => showPersona('user'));
  btnCreator.addEventListener('click', () => showPersona('creator'));
  window.addEventListener('resize', () => setSlider(btnUser.classList.contains('active') ? btnUser : btnCreator));
  window.addEventListener('load', () => setSlider(btnUser));

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(item => {
    item.querySelector('.faq-q').addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if(!isOpen) item.classList.add('open');
    });
  });
</script>

</body>
</html>
`;
